import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { SiGithub} from "react-icons/si";
import {FiLink} from 'react-icons/fi';


export default function Projects({image,author,title,description,link,github,webLink}) {
  return (
    <div className="article__item" rel="noreferrer" data-aos="zoom-in" >
      <LazyLoadImage className="article__image" alt={title} effect='blur' src={image} width='100%'/>
        <div className="article__text">
          <div className="article__author">{author}</div>
          <div className="article__title">{title}</div>
          <div className="article__description">{description}</div>
        </div>
        <div className='work-link'>
          <a target="_blank" rel='noreferrer' href={github} className="icon"><SiGithub /></a>
          <a target="_blank" rel='noreferrer' href={webLink} className="icon"><FiLink/></a>
        </div>
    </div>
  );
}

